export const getMetaComponents = (state) => state.metaComponents;

export const isCurruntMetaComponentFetching = (state, endpoint) => {
  const metaComponentsState = getMetaComponents(state);
  const component = metaComponentsState[endpoint]
    ? metaComponentsState[endpoint]
    : {};

  const { isFetching = false } = component;

  return isFetching;
};
